import React from "react"
import EditCollectionForm from "./EditCollectionForm"
import { styled } from "@mui/material/styles"
import { css } from '@emotion/react';

import {
  Button,
  ButtonGroup,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip
} from "@mui/material"
import { inject, observer } from "mobx-react"
import {
  MINIMUM_COLLECTION_SIZE,
} from "../utils/samplefocusDefaults"


const AssignCollectionAccordionContainer = styled('div')``

const AccordionLabel = styled('label')`
  font-weight: 600;
`

const SFAccordionSummary = styled(AccordionSummary)`
  background-color: whitesmoke;
`

const SFButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isPressed',
})(({ theme, isPressed }) => ({
  backgroundColor: isPressed ? "rgba(0, 0, 0, 0.08)" : "inherit",
  height: "100%",
}));

const SFFormControl = styled(FormControl)`
  .MuiInputBase-root,
  .MuiInputLabel-root {
    font-family: Lato;
  }
`

const SFMenuItem = styled(MenuItem)`
  font-family: Lato;
  font-weight: 300;
`

@inject("sampleStore")
@inject("collectionStore")
@observer
export default class AssignCollectionAccordion extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      paneToShow: null,
      selectedCollection: null,
    }
  }

  handleClickCreateCollection = (e) => {
    e.stopPropagation()
    const { paneToShow } = this.state
    if (paneToShow === "CreateCollection") {
      this.setState({ paneToShow: null })
    } else {
      this.setState({ paneToShow: "CreateCollection" })
    }
  }

  handleClickAddToCollection = (e) => {
    e.stopPropagation()
    const { paneToShow } = this.state
    if (paneToShow === "AddToCollection") {
      this.setState({ paneToShow: null })
    } else {
      this.setState({ paneToShow: "AddToCollection" })
    }
  }

  handleAccordionSummaryClick = () => {
    const { paneToShow } = this.state
    if (paneToShow) {
      this.setState({ paneToShow: null })
    }
  }

  handleCollectionSelect = (e) => {
    const { collectionStore } = this.props
    const selectedId = e.target.value
    const selectedCollection = collectionStore.availableCollections.filter(
      (c) => c.id == selectedId
    )[0]
    this.setState({ selectedCollection: selectedCollection })
  }

  handleAddToCollection = async () => {
    const { selectedCollection } = this.state
    const { sampleStore, collectionStore } = this.props
    const didAssign = await selectedCollection.assignSamples(
      sampleStore.sampleIds
    )
    if (didAssign) {
      collectionStore.focusedCollection = selectedCollection
      selectedCollection.isPersisted = true
    }
  }

  renderAddToCollection() {
    const { collectionStore } = this.props
    const { selectedCollection } = this.state
    return (
      <div
        css={css`
          display: flex;
          width: 100%;
          align-items: center;
          height: 55px;
        `}
      >
        <SFFormControl
          fullWidth
          variant="outlined"
          style={{ marginRight: 10, maxWidth: 350 }}
        >
          <InputLabel id="collection">Select a collection</InputLabel>
          <Select
            labelId="collection"
            id="select"
            label="collection"
            name="collection"
            onChange={this.handleCollectionSelect}
            value={selectedCollection ? selectedCollection.id : null}
          >
            {collectionStore.availableCollections.map((collection) => {
              return (
                <SFMenuItem value={collection.id} key={collection.id}>
                  {collection.name}
                </SFMenuItem>
              )
            })}
          </Select>
        </SFFormControl>
        <SFButton
          onClick={this.handleAddToCollection}
          variant="outlined"
          color="primary"
          size="medium"
        >
          Add to Collection
        </SFButton>
      </div>
    )
  }

  render() {
    const { paneToShow } = this.state
    const { collectionStore, sampleStore } = this.props
    const minimumSamplesMet = sampleStore.samples.length >= MINIMUM_COLLECTION_SIZE;
    const createCollectionDisabled = !Boolean(minimumSamplesMet)

    return (
      <AssignCollectionAccordionContainer>
        <Accordion expanded={paneToShow !== null}>
          <SFAccordionSummary
            expandIcon={
              paneToShow ? (
                <i className="fas fa-angle-down" aria-hidden="true"></i>
              ) : null
            }
            onClick={this.handleAccordionSummaryClick}
          >
            <AccordionLabel>
              <ButtonGroup size="large">
                <Tooltip title={createCollectionDisabled ? `You need at least ${MINIMUM_COLLECTION_SIZE} samples to create a collection.` : ""}>
                  <span>
                    <SFButton
                      onClick={this.handleClickCreateCollection}
                      isPressed={paneToShow === "CreateCollection"}
                      disabled={createCollectionDisabled}
                    >
                      Create a Collection
                    </SFButton>
                  </span>
                </Tooltip>
                {collectionStore.availableCollections.length > 0 && (
                  <SFButton
                    onClick={this.handleClickAddToCollection}
                    isPressed={paneToShow === "AddToCollection"}
                  >
                    Add to an existing Collection
                  </SFButton>
                )}
              </ButtonGroup>
            </AccordionLabel>
          </SFAccordionSummary>
          <AccordionDetails>
            {paneToShow === "CreateCollection" ? (
              <EditCollectionForm collection={collection} />
            ) : (
              this.renderAddToCollection()
            )}
          </AccordionDetails>
        </Accordion>
      </AssignCollectionAccordionContainer>
    )
  }
}
